import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../redux";
import { getFarmaciaByRegionalCode } from "../../../redux/reducer/surveyReportReducer";
import HeaderModal from "../../../components/headerModal";
import TitleModal from "../../../components/common/titleModal";
import HeaderSection from "../../../components/header-section";

// Component starts
const FarmaciaDetail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  /**
   * Get url params.
   */
  const location = useLocation();
  const { name, region } = location.state || {};

  /**
   * redux hooks.
   */
  const { surveysReport } = useSelector((state: any) => state);
  const { farmacia } = surveysReport;

  useEffect(() => {
    if (region) {
      fetchData(region);
    }
  }, [region]);

  /**
   * fetch citizen and surverys data on page load.
   */
  const fetchData = async (region: any) => {
    dispatch(getFarmaciaByRegionalCode(region));
  };

  /**
   * returns individual farmacia data.
   */
  const renderLabelValue = (label: string, value: string) => {
    return (
      <div className="survey-field">
        <label className="fw-bold showCharacters text-capitalize">
          {label}
        </label>
        <label className="label-sm">{value}</label>
      </div>
    );
  };

  return (
    <>
      <HeaderModal
        textButtonRight={t("new-group-link-modal.error-back")}
        handleClick={() =>
          navigate(`/surveys/farmacia/report`, {
            state: {
              name: name,
              region: region,
            },
          })
        }
      />
      <div className="page-title">
        <HeaderSection visibleButton={false} titleSection={farmacia.name} />
      </div>
      <div className="container-box mb-3 d-flex justify-content-center">
        <div className="survey-wrapper-box col-md-6">
          <div className="col-md-11 mt-2">
            {/* basic information */}
            <TitleModal title={t("site")} />
            {renderLabelValue(t("address"), farmacia.address)}
            {renderLabelValue(t("province"), farmacia.district)}
            {renderLabelValue(t("city"), farmacia.city)}
            {renderLabelValue(t("region-code"), farmacia.code)}
            {renderLabelValue(t("vat-code"), farmacia.vatCode)}
            <div className="mt-3" />
            {/* contact information */}
            <TitleModal title={t("contact")} />
            {renderLabelValue(t("phone"), farmacia.phone)}
            {renderLabelValue(t("email"), farmacia.email)}
          </div>
        </div>
      </div>
    </>
  );
};

export default FarmaciaDetail;
